window.PH = window.PH || {};

PH.advisor = {
  normalize(text) {
    return String(text || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9\s]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  },

  getAdvice(query, results) {
    if (!query || query.length < 2 || !results.length) return null;

    const intent = PH.intents && typeof PH.intents.detect === 'function'
      ? PH.intents.detect(query)
      : null;

    if (intent) {
      return {
        icon: intent.icon,
        title: intent.title,
        description: intent.description,
        intentId: intent.id
      };
    }

    return {
      icon: '✨',
      title: 'Recomendación PH',
      description: `Encontramos ${results.length} opciones que pueden encajar con tu búsqueda.`,
      intentId: null
    };
  }
};